const issue = () => import ('@/pages/bill-issue/issue')

export default [
    {
        path: 'bill-issue/issue',
        name:'bill-issue/issue',
        component: issue
    }
]



// WEBPACK FOOTER //
// ./src/router/bill-issue.js